module.exports = __webpack_public_path__ + "static/media/m_eyeshape_round_blue.34e679b5.png";